export default {
  title_one: 'Bezorgstatistieken worden bijgewerkt voor „{{title}}"',
  title_other: 'Bezorgstatistieken worden bijgewerkt voor {{count}} campagnes',
  subtitle_pending:
    'Apple en Google bevestigen ontvangsten in ongeveer {{minutes}}m {{seconds}}s (rond {{time}}). De statistieken worden automatisch vernieuwd.',
  subtitle_ready:
    'Ontvangstbewijzen zouden binnen moeten zijn. Vernieuw de pagina voor de meest recente bezorgcijfers.',
};
